import { Directive,HostListener,Input } from '@angular/core';


@Directive({
  selector: '[eventTrackerRegistrarme]'
})
export class RegistrarmeDirective {

  @Input('eventTrackerRegistrarme') option:any;

  @HostListener('click', ['$event']) onClick($event){

    (<any>window).gtag('send', 'event', this.option.category, this.option.action,this.option.label, {
      hitCallback: function() {

      }

    });

  }
  constructor() { }

}